import { Application, Controller } from '@hotwired/stimulus'
import { ChildFlow, UserDataValue } from '../../api/models/types'
import { connectUserData, getComponentContext } from '../../helpers/controllerHelpers/utils'
import FlowController from '../flow_controller'

export default class extends Controller {
  static values = {
    id: String,
    popupMode: String,
    attributes: Object,
  }
  static targets = ['savvy']
  // declare savvyTarget: HTMLElement
  declare savvyEl: HTMLElement
  declare lastElId: string | null
  declare popupModeValue: Boolean
  declare attributesValue: String
  declare idValue: String
  declare userDataValue: Object
  disconnectUserData?: () => void
  component: ChildFlow

  flowIdValueObserver: MutationObserver

  connect() {
    const savvyEl = this.element.querySelector('savvy') as HTMLElement
    if (!savvyEl) throw new Error('ChildFlow component must have a <savvy> element')
    const { component } = getComponentContext(this)
    this.component = component as ChildFlow
    this.userDataValue = this.component?.userData || {}
    this.disconnectUserData = connectUserData(this, this.updateChildFlowUserData, true)
    this.savvyEl = savvyEl
    this.watchFlowIdValue()
  }

  disconnect() {
    if (typeof this.disconnectUserData === 'function') this.disconnectUserData()
    if (this.flowIdValueObserver) this.flowIdValueObserver.disconnect()
  }

  popupModeValueChanged(current: string, prev: string) {
    if (prev && current !== prev) {
      this.savvyEl.setAttribute('popup-mode', current)
    }
  }

  attributesValueChanged(current: object, prev: object) {
    if (!current) return

    if (Object.keys(prev || {}).length > 0) {
      Object.keys(current).map((key) => this.savvyEl.setAttribute(key, current[key]))
    }
  }

  // idValueChanged(current: string, prev: string) {
  //   if (prev) {
  //     this.savvyTarget.setAttribute('id', current)
  //   }
  // }

  watchFlowIdValue() {
    // Watch for changes to the id attribute of this.savvyEl
    const self = this
    this.lastElId = this.savvyEl.getAttribute('id')

    // let i = 0

    this.flowIdValueObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.target === self.savvyEl &&
          mutation.attributeName === 'id'
        ) {
          const newId = self.savvyEl.getAttribute('id')

          if (!newId) {
            // Remove all children of this.savvyEl
            while (self.savvyEl.firstChild) {
              self.savvyEl.removeChild(self.savvyEl.firstChild)
            }
            self.lastElId = null
            return
          }

          if (newId === self.lastElId) return
          self.lastElId = self.savvyEl.getAttribute('id')

          // Replace self.savvyEl with a new identical element
          const newSavvyTarget = document.createElement('savvy')
          // newSavvyTarget.setAttribute('id', newId)
          // Copy all attributes from self.savvyEl to newSavvyTarget
          for (let i = 0; i < self.savvyEl.attributes.length; i++) {
            const attr = self.savvyEl.attributes.item(i)
            if (attr?.name === 'id') newSavvyTarget.setAttribute('id', `flow-${attr.value}`)
            if (attr) newSavvyTarget.setAttribute(attr.name, attr.value)
          }
          self.savvyEl.parentNode?.replaceChild(newSavvyTarget, self.savvyEl)
          self.savvyEl = newSavvyTarget
        }
      })
    })
    const config = { attributes: true, subtree: true }
    this.flowIdValueObserver.observe(this.element, config)

    // Stop observing when the element is removed from the DOM
    // this.element.addEventListener('DOMNodeRemoved', () => {
    //   observer.disconnect()
    // })
  }

  updateChildFlowUserData(newUserData?: UserDataValue) {
    const userData = newUserData || this.userDataValue
    const flowEl = this.savvyEl?.querySelector('[data-controller*="flow"]')
    const flowController =
      flowEl &&
      (this.application.getControllerForElementAndIdentifier(flowEl, 'flow') as FlowController)
    const updates = this.component?.parent_field_bindings?.reduce((acc, key) => {
      return { ...acc, ...{ [key]: userData[key] } }
    }, {})

    if (!newUserData) {
      return { ...updates }
    }

    flowController &&
      flowController.batchUpdate({
        detail: {
          updates,
        },
      })
  }
}
